import seekIcon from '../assets/icons/IconSeek.png';
import maintenanceIcon from '../assets/icons/Maintenance.png';
import directionIcon from '../assets/icons/Direction_large.png';
import second from '../assets/icons/ish-icon-2nd.png';
import threePercent from '../assets/icons/ish-icon-3-percent.png';
import seventyFivePercent from '../assets/icons/ish-icon-75-percent.png';
import accessKey from '../assets/icons/ish-icon-access-key.png';
import advanced from '../assets/icons/ish-icon-advanced.png';
import advanced48x48 from '../assets/icons/ish-icon-advanced_48x48.png';
import arrowDownTrend from '../assets/icons/ish-icon-arrow-down-trend.png';
import arrowTwoForward from '../assets/icons/ish-icon-arrow-two-forward.png';
import arrowTwoRotating from '../assets/icons/ish-icon-arrow-two-rotating.png';
import arrowUpTrend from '../assets/icons/ish-icon-arrow-up-trend.png';
import arrowsThreeWaySplit from '../assets/icons/ish-icon-arrows-three-way-split.png';
import avatarButtons from '../assets/icons/ish-icon-avatar-buttons.png';
import avatarCollarButton from '../assets/icons/ish-icon-avatar-collar-button.png';
import avatarCollar from '../assets/icons/ish-icon-avatar-collar.png';
import avatarCouple from '../assets/icons/ish-icon-avatar-couple.png';
import aware from '../assets/icons/ish-icon-aware.png';
import aware48x48 from '../assets/icons/ish-icon-aware_48x48.png';
import binoculars from '../assets/icons/ish-icon-binoculars.png';
import briefcase96x84 from '../assets/icons/ish-icon-briefcase_96x84.png';
import broad from '../assets/icons/ish-icon-broad.png';
import broad48x48 from '../assets/icons/ish-icon-broad_48x48.png';
import bullseyeTarget from '../assets/icons/ish-icon-bullseye-target.png';
import camera from '../assets/icons/ish-icon-camera.png';
import chipCreditCard from '../assets/icons/ish-icon-chip-credit-card.png';
import circuitBoard from '../assets/icons/ish-icon-circuit-board.png';
import circleWideCanvasTest from '../assets/icons/icon-circle-wide-canvas-test.png';
import numberOne from '../assets/icons/number-one.png';
import numberTwo from '../assets/icons/number-two.png';
import numberThree from '../assets/icons/number-three.png';
import numberFour from '../assets/icons/number-four.png';
import esg from '../assets/icons/ESG-1-1.png';
import calculator from '../assets/icons/calculator-1-1.png';
import global from '../assets/icons/global-1-1.png';
import people from '../assets/icons/people-1-1.png';
import urbanization from '../assets/icons/urbanization-1-1.png';
import * as svgIcons from './svg';

export type FontAwesomeIcon =
	| 'fa-angle-right'
	| 'fa-download'
	| 'fa-envelope-o'
	| 'fa-calendar'
	| 'fa-film'
	| 'far fa-camcorder'
	| 'far fa-podcast'
	| 'fas fa-lock'
	| 'fas fa-envelope-open-text';

export const FontAwesomeIcons: { [index: string]: FontAwesomeIcon } = {
	General: 'fa-angle-right',
	Download: 'fa-download',
	Email: 'fa-envelope-o',
	Event: 'fa-calendar',
	Video: 'fa-film',
	Webinar: 'far fa-camcorder',
	Podcast: 'far fa-podcast',
	Lock: 'fas fa-lock',
	Subscribe: 'fas fa-envelope-open-text',
};

export const PngIcons = {
	'Access Key': accessKey,
	Advanced: advanced,
	'Advanced 48x48': advanced48x48,
	'Arrow Down Trend': arrowDownTrend,
	'Arrow Two Forward': arrowTwoForward,
	'Arrow Two Rotating': arrowTwoRotating,
	'Arrow Up Trend': arrowUpTrend,
	'Arrows Three Way Split': arrowsThreeWaySplit,
	'Avatar Buttons': avatarButtons,
	'Avatar Collar Button': avatarCollarButton,
	'Avatar Collar': avatarCollar,
	'Avatar Couple': avatarCouple,
	Aware: aware,
	'Aware 48x48': aware48x48,
	Binoculars: binoculars,
	'Briefcase 96x84': briefcase96x84,
	Broad: broad,
	'Broad 48x48': broad48x48,
	'Bullseye Target': bullseyeTarget,
	Calculator: calculator,
	Camera: camera,
	'Chip Credit Card': chipCreditCard,
	'Circuit Board': circuitBoard,
	'Circle With Wide Canvas': circleWideCanvasTest,
	Direction: directionIcon,
	Esg: esg,
	Global: global,
	'Magnifying Glass': seekIcon,
	Maintenance: maintenanceIcon,
	People: people,
	Urbanization: urbanization,
	One: numberOne,
	Two: numberTwo,
	Three: numberThree,
	Four: numberFour,
	Second: second,
	'Seventy-five Percent': seventyFivePercent,
	'Three Percent': threePercent,
};

export const SvgIcons = {
	'Icon Hash': svgIcons.IconHash,
	'Icon Bar': svgIcons.IconBar,
	'Icon Pie': svgIcons.IconPie,
	'Icon Education': svgIcons.IconEducation,
	'Icon Puzzle': svgIcons.IconPuzzle,
	'Five Point Six Percent': svgIcons.IconFivePointSixPercent,
	'Seventy-six Percent': svgIcons.IconSeventySixPercent,
	'Arrow Diverging': svgIcons.IconArrowDiverging,
	'Arrow Downward': svgIcons.IconArrowDownward,
	'Arrow Triple': svgIcons.IconArrowTriple,
	'Arrow Upward': svgIcons.IconArrowUpward,
	'Arrows Forward': svgIcons.IconArrowsForward,
	'Arrows Rotating': svgIcons.IconArrowsRotating,
	'Avatar Double': svgIcons.IconAvatarDouble,
	'Avatar Single 1': svgIcons.IconAvatarSingle1,
	'Avatar Single 2': svgIcons.IconAvatarSingle2,
	'Avatar Single 3': svgIcons.IconAvatarSingle3,
	Balloons: svgIcons.IconBalloons,
	'Bars Vertical Uneven': svgIcons.IconBarsVerticalUneven,
	'Bars Vertical': svgIcons.IconBarsVertical,
	Basket: svgIcons.IconBasket,
	Calculator: svgIcons.IconCalculator,
	'Circle Pulse': svgIcons.IconCirclePulse,
	'Water Drop': svgIcons.IconWaterDrop,
};

export const socialMediaIcons = {
	facebook: 'fa fa-facebook',
	linkedin: 'fa fa-linkedin',
	twitter: 'fa fa-twitter',
	youtube: 'fa fa-youtube',
	'blk-blog': 'fa fa-rss',
};
